import React from 'react';
import Text from '@service-victoria/component-library/components/Text';
import CircleTick from '@service-victoria/component-library/components/Icons/CircleTick';
import ThumbDown from '@service-victoria/component-library/components/Icons/ThumbDown';
import ThumbUp from '@service-victoria/component-library/components/Icons/ThumbUp';
import colors from '@service-victoria/component-library/utils/colors';
import { CircleTickWrapper, ThumbWrapper } from './styled';
// import { ThumbDown, ThumbUp } from '../Icons';

export type ComponentProps = {
  type: 'up' | 'down';
  onClick: () => any;
  disabled: boolean;
  selected: boolean;
  feedbackText: string;
};

const FeedbackItem: React.FC<ComponentProps> = ({
  type = 'up',
  onClick = () => {},
  disabled = false,
  selected = false,
  feedbackText
}) => {
  return (
    <ThumbWrapper type='button' onClick={onClick} disabledStyle={disabled} selected={selected}>
      {selected && (
        <CircleTickWrapper>
          <CircleTick fill={colors.orange} />
        </CircleTickWrapper>
      )}
      {type === 'up' ? (
        <ThumbUp selected={selected} disabled={disabled} />
      ) : (
        <ThumbDown selected={selected} disabled={disabled} />
      )}
      <Text.Body fontWeight={500} as='span'>
        {feedbackText}
      </Text.Body>
    </ThumbWrapper>
  );
};

export default FeedbackItem;
